<template>
    <div>
        <page-title heading="Penjualan" :breadcrumb="[
            {
                label: 'Dashboard',
                link: '/'
            },
            {
                label: 'Penjualan',
                active: true
            }
        ]" />
        <div class="container-fluid">
            <div class="card card-box ninja-shadow mt-3">
                <div class="card-body">
                    <b-row class="head-filter">
                        <b-col md="2" class="pr-0">
                            <label class="lb-header-filter" style="margin-bottom:15px;">Hari, Tanggal</label>
                            <date-picker v-model="from" type="date" range format="DD-MM-YYYY" value-type="YYYY-MM-DD"
                                placeholder="DD-MM-YYYY" :style="'width: 130%'" @input="searchValueChanged($event, 'from')">
                            </date-picker>
                        </b-col>
                    </b-row>
                    <div class="stright-line"></div>
                    <b-col md="12">
                        <DataTableWrapper :perPage="perPage" :fromPage="fromPage" :toPage="toPage"
                            :totalEntries="totalEntries" :currentPage="currentPage" :callbackFunc="fetchListPenjualan"
                            @valueChanged="handleValueChanged">
                            <template #right-header>
                                <b-button variant="success" size="md" class="text-uppercase align-self-end" :to="{
                                    name: 'klinik-penjualan-tambah'
                                }">Buat Penjualan</b-button>
                            </template>
                            <b-table thead-tr-class="izd-datatable" :items="farmasiList" :fields="fieldList"
                                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true">
                                <template v-slot:head()="data">
                                    {{ data.label }}
                                    <b-input size="sm" class="mt-2 w-95" v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)" />
                                </template>
                                <template v-slot:head(status)="data">
                                    {{ data.label }}
                                    <select class="form-control select-status" @input="
                                        searchValueChanged($event.target.value, data.field.key)
                                        ">
                                        <option value="">Semua</option>
                                        <option value="BELUM LUNAS">Belum Lunas</option>
                                        <option value="LUNAS">Lunas</option>
                                    </select>
                                </template>
                                <template v-slot:head(metode_pembayaran)="data">
                                    {{ data.label }}
                                    <select class="form-control select-status" @input="
                                        searchValueChanged($event.target.value, data.field.key)
                                        ">
                                        <option value="">Semua</option>
                                        <option value="TUNAI">Tunai</option>
                                        <option value="TRANSFER">Transfer</option>
                                        <option value="QRIS">QRIS</option>
                                    </select>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <span :class="{ 'text-danger': !isPaidOff(data.item.status) }">
                                        {{ data.item.status }}
                                    </span>
                                </template>
                                <template v-slot:cell(total_net)="data">
                                    <div>
                                        <span>{{ data.item.total_net | formatRupiah }}</span>
                                    </div>
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <span class="d-flex align-items-center justify-content-between">
                                        <b-dropdown id="dropdown-left" variant="primary" size="sm">
                                            <template #button-content>
                                                <font-awesome-icon icon="clone" />
                                            </template>
                                            <b-dropdown-item v-if="isPaidOff(data.item.status)" @click="
                                                isPaidOff(data.item.status)
                                                    ? showReceipt(data.item.id)
                                                    : () => { }
                                                ">Lihat Struk</b-dropdown-item>
                                            <b-dropdown-item v-if="isPaidOff(data.item.status)"
                                                @click="showPembayaran(data.item.id)">
                                                Atur Komisi
                                            </b-dropdown-item>
                                            <b-dropdown-item v-if="!isPaidOff(data.item.status)"
                                                @click="showPembayaran(data.item.id)">
                                                Detail Transaksi
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </span>
                                </template>
                                <template v-slot:cell(updated)="data">
                                    <label style="font-size:12px;">
                                        {{ data.item.updated.at }} <br>
                                        by <b>{{ data.item.updated.by }}</b>
                                    </label>
                                </template>
                            </b-table>
                        </DataTableWrapper>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from "lodash/debounce";
import { mapGetters } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";

export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper"),
        DatePicker
    },
    data() {
        return {
            sortBy: "",
            sortDesc: false,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            perPage: 10,
            farmasiList: [],
            searchValue: [],
            totalEntries: 0,

            firstLoadPenjualan: true,
            from: [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")],
        }
    },
    computed: {
        ...mapGetters({
            isDoctor: "doctorRole",
            getRolesName: "getRolesName",
            getKlinikId: "getKlinikId"
        }),
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(actions|updated)\b/gi.test(val) ? !1 : 1);
            return (
                [
                    {
                        key: "hari",
                        label: "hari, tanggal"
                    },
                    {
                        key: "no_invoice",
                        label: "no.invoice",
                    },
                    {
                        key: "status",
                        label: "status pembayaran",
                        thStyle: "width: 200px",
                    },
                    {
                        key: "metode_pembayaran",
                        label: "metode pembayaran",
                        thStyle: "width: 200px",
                    },
                    {
                        key: "total_net",
                        label: "total",
                    },
                    {
                        key: "actions"
                    },
                    { key: "updated", label: "last modified" },
                ]
                |> (v => s({ field: v, customFunc: r }))
                |> (z => g({ field: z }))
            );
        }
    },
    watch: {
        currentPage() {
            this.fetchListPenjualan();
        },
        perPage() {
            this.fetchListPenjualan();
        },
        sortBy() {
            this.fetchListPenjualan();
        },
        sortDesc() {
            this.fetchListPenjualan();
        },
        searchValue: {
            handler: function (val) {
                if (!this.firstLoadPenjualan) this.fetchListPenjualan();
            },
            deep: true
        },
    },
    methods: {
        getTodayDate() {
            return [moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")];
        },
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function (val, key) {
            if (key == "from" && val[0] == null && val[1] == null) {
                val = this.from = this.getTodayDate()
            }
            const { searchValue } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";
            searchValue.map(item => {
                const x = item.key;
                if (item.key == "from") {
                    v += `&from=${item.value[0] || ""}`;
                    v += `&to=${item.value[1] || ""}`;
                } else {
                    v += `&${x}=${item.value || ""}`;
                }
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }

            return v;
        },
        async fetchListPenjualan() {
            try {
                if (this.firstLoadPenjualan) {
                    this.searchValue = [
                        {
                            key: "from",
                            value: this.from
                        }
                    ];
                }
                const res = await this.$axios.get(
                    `penjualan?klinik_id=${this.getKlinikId}&limit=${this.perPage
                    }&page=${this.currentPage}${this.determineParameter()}`
                );
                this.firstLoadPenjualan = false;
                const { status, data } = res.data;
                if (status) {
                    const {
                        data: listFarmasi,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = data;
                    this.totalEntries = totalEntries;
                    this.toPage = toPage;
                    this.fromPage = fromPage;
                    this.farmasiList = [
                        ...listFarmasi.map((item, index) => {
                            return {
                                ...item,
                                no: (this.currentPage - 1) * this.perPage + index + 1,
                                updated: {
                                    at: moment(item.updated.at).format("MMM DD, YYYY @ HH:mm"),
                                    by: item.updated.by || 'anonim'
                                }
                            };
                        })
                    ];
                    this.rows = data.total;
                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        },
        isPaidOff(status) {
            return status.toLowerCase() == "lunas";
        },
        showReceipt(id) {
            this.$router.push({
                name: "klinik-penjualan-struk",
                params: {
                    id: id
                }
            });
        },
        showPembayaran(id) {
            this.$router.push({
                name: "klinik-penjualan-tambah-save",
                params: {
                    id: id
                }
            });
        },
    },
    filters: {
        formatRupiah(value) {
            if (!value) return 'Rp 0';

            // Convert the number to an integer to remove decimals
            const intValue = Math.floor(value);

            // Format the integer as Rupiah
            const formattedValue = new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0, // Set minimumFractionDigits to 0
            }).format(intValue);

            return formattedValue;
        },
    }
}
</script>

<style lang="css" scoped>
.select-status {
    margin-top: 7px;
    height: 30px;
    font-size: 11pt;
    padding: 0;
}

.select-status option {
    font-size: 9pt;
}

.lb-header-filter {
    color: #217fc3;
    font-weight: 600;
}

.mx-datepicker .mx-input {
    height: 41.7px !important;
}


.ninja-shadow {
    box-shadow: 0px 8px 15px 0px lightgrey;
}

.head-filter {
    margin: 20px 0;
}

.stright-line {
    background-color: #dcecec;
    height: 2px;
    margin: 20px 0;
}

/* width */
#pembayaran-table::-webkit-scrollbar {
    width: 5px;
}

/* Track */
#pembayaran-table::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px grey;
    border-radius: 10px;
}

/* Handle */
#pembayaran-table::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 10px;
}

/* Handle on hover */
#pembayaran-table::-webkit-scrollbar-thumb:hover {
    background: #cdcdcd;
}

@media screen and (max-width: 1380px) {
    .sticky-header-pembayaran {
        width: 135%;
    }
}

.sticky-header-pembayaran {
    width: 120%;
}

.sticky-header-pembayaran th {
    position: -webkit-sticky;
    position: sticky;
    top: -2px;
    z-index: 1;
}
</style>